<template>
  <div class="aboutCEO">
    <div class="compTitle">亲爱的各位盛唐中融同仁、尊敬的合作伙伴、社会各界朋友们：</div>
    <div class="compText">你们好：</div>
    <div class="middle">
      <div>
        <div class="compText">自我2001 年加入保险行业大军，不知不觉已走过二十个春秋。如果把1992 年代理人制度兴起看做是中国现代保险业的元年，在这波澜壮阔的三十年中，三分之二的过程我亲历见证，何其有幸！
        </div>
        <div class="compText">随着2021
          上半年中国保险深度突破5%，保险行业不仅走进千家万户，更是让各行各业、千万家庭感受到了保险带来的强大功能和爱与责任。放眼下一个十年，充满了时代巨变的机遇与挑战，盛唐中融在这样的大时代背景下破土而出，我们满怀星辰大海又深知须脚踏实地，用中融人的勇气与智慧积极拥抱未来！
        </div>
        <div class="compText">
          时代更迭带来社会结构的剧变，在万物互联的智能化时代，普惠保障型产品已然成为显性刚需。另一方面，人口老龄化加速以及公民平均寿命的增长将养老问题拉近视野，养老三大支柱成为社会共识，商业养老存在巨量市场空间，井喷式增长近在眼前。
        </div>
        <div class="compText">随着“80 后”渐成社会中坚，“90
          后”群体迅速崛起，更高的教育程度和更强的信息沟通能力催生出对更高专业品质的追求。互联网使得曾经的信息鸿沟不复存在，保险不仅成为品质生活标配，优质的产品及服务体验将成为衡量价值感的重要指标。</div>
        <div class="compText">改革开放40 余年，财富的积累孕育出庞大的中高端客户群体。伴随多项税制改革的信号释放、财富传承市场的巨大需求，保险强大且不可替代的金融属性越来越被市场所关注。</div>
      </div>
      <div class="compImg">
        <img src="../assets/images/brief_picture.png" alt="">
      </div>
    </div>
    <div class="compText">随着独立代理人制度在深圳、河北等地相继落地，专业化保险服务已成为行业最强音。传统的“金字塔”模式必将逐步打破，独立性、精英化、高专业是行业发展不可阻挡的洪流。</div>
    <div class="compText">
      立于时代路口，这一切的一切都将成为盛唐中融人前行路上的使命与追求，行业千百万保险人值得被更好的培养、值得被更好的关爱。打造成为『中国最具亲和力的保险人事业平台』是我们为之奋斗终身的愿景；『做保险人一生的事业伙伴』是盛唐中融矢志不渝的使命；『自主、快乐、分享、成长、价值』塑造平台文化根基。盛唐中融的经纪人伙伴们是公司最为宝贵的财富。每一个伙伴、每一个团队、每一个事务所都拥有自主选择发展模式的权利与自由，我们要做的就是给你们最大的信任与支持；我要让你们快乐，是那种事业成就后的风姿卓越、把酒言欢、喜逐颜开，快乐理应是人生中最浓墨重彩的那一笔勾勒；平台之上处处分享可见可得，分享是阳光、温暖你我世界；分享是雨露、滋润干涸心田；分享是春风、拂去灵魂尘埃；今天的你必将比昨日优秀，未来的你定将成为行业栋梁，我们共同成长，彼此成就；假以时日，你将成为客户、市场赞誉的保险人，你的品牌铿锵有力。今日盛唐中融供你沃土，未来平台以你为荣！
    </div>
    <div class="compText">
      身处纷繁复杂、风起云涌的市场前沿，无论是社会经济环境的瞬息万变，还是信息技术的快速更迭，机遇与挑战无处不在。盛唐中融的选择是直面挑战、敢于担当、永不言败。我们最大的自信在于：拥有特别能奋进、特别讲奉献的服务团队；拥有特别有专业、特别可成长的精英经纪人团队；拥有行业领先的基本法、事务所经营模式及配套支持；拥有强大的股东实力和对保险板块一如既往的情怀与投入。
    </div>
    <div class="compText">
      从寿险服务商到全保险服务商，再到覆盖生命全周期的综合服务商，将盛唐中融打造成“中国最具亲和力的保险人事业平台”，这就是我与全体盛唐中融人的梦想。这样的梦想在酝酿之初不过是一颗水滴，我相信经过我们的努力，终会滴水成河，千流入海，成为浩瀚汪洋；这样的梦想在创业之初不过是一束微光，我相信经过我们的努力，终会燃起保险专业中介的燎原之火；这样的梦想在动之初不过是一张白纸，我相信经过我们的努力，终会描绘保险中介行业伟大蓝图，精彩无限。
    </div>
    <div class="compText">共创、共担、共赢。</div>
    <div class="compText">我们永远有一颗年轻的心，我们永远怀一束梦想的光，我们永远在路上！</div>

    <div class="sign">
      <div class="compText">盛唐中融总裁</div>
      <div>
        <img src="../assets/images/brief_signature.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'aboutCEO',
    components: {},
    data() {
      return {

      }
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .aboutCEO {
    .middle {
      display: flex;

      .compImg {
        margin-left: 20px;
        margin-top: 30px;
      }
    }

    .sign {
      height: 150px;
      position: relative;

      div {
        position: absolute;
        right: 0;
        img{
          margin-top: 50px;
        }
      }
    }
  }
</style>